import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils/apiClient';
import { CREATE_DATASET_URL, DATASETS_URL, DATASET_BY_ID_URL, DEFAULT_PAGE_LIMIT } from '../../constants/apiEndpoints';

// Async thunks
export const createDataset = createAsyncThunk(
    'dataset/createDataset',
    async (datasetData, { rejectWithValue }) => {
        try {
            return await apiFetch(CREATE_DATASET_URL, {
                method: 'POST',
                body: JSON.stringify(datasetData)
            });
        } catch (error) {
            return rejectWithValue({
                message: error.message,
                detail: error.detail
            });
        }
    }
);

export const fetchDatasets = createAsyncThunk(
    'dataset/fetchDatasets',
    async ({ data_provider_id, limit = DEFAULT_PAGE_LIMIT, offset = 0 }, { rejectWithValue }) => {
        try {
            return await apiFetch(
                DATASETS_URL(data_provider_id, limit, offset),
                { method: 'GET' }
            );
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchDatasetById = createAsyncThunk(
    'dataset/fetchDatasetById',
    async (dataset_id, { rejectWithValue }) => {
        try {
            return await apiFetch(
                DATASET_BY_ID_URL(dataset_id),
                { method: 'GET' }
            );
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const datasetSlice = createSlice({
    name: 'dataset',
    initialState: {
        datasets: [],
        currentDataset: null,
        loading: false,
        error: null,
        createdDatasetId: null
    },
    reducers: {
        clearDatasetError: (state) => {
            state.error = null;
        },
        clearCreatedDataset: (state) => {
            state.currentDataset = null;
            state.createdDatasetId = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create Dataset
            .addCase(createDataset.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createDataset.fulfilled, (state, action) => {
                state.loading = false;
                state.currentDataset = action.payload;
                // Backend returns DatasetID in PascalCase
                state.createdDatasetId = action.payload.DatasetID;
            })
            .addCase(createDataset.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Fetch Datasets
            .addCase(fetchDatasets.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDatasets.fulfilled, (state, action) => {
                state.loading = false;
                state.datasets = action.payload.datasets || action.payload;
            })
            .addCase(fetchDatasets.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Fetch Dataset By ID
            .addCase(fetchDatasetById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDatasetById.fulfilled, (state, action) => {
                state.loading = false;
                state.currentDataset = action.payload;
            })
            .addCase(fetchDatasetById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearDatasetError, clearCreatedDataset } = datasetSlice.actions;
export default datasetSlice.reducer;
